import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import LayoutCheck from './beforeEnter';

import AdminRouter from '@/components/admin/@config/router';
import ProductRouter from '@/components/product/@config/router';
import MenuRouter from '@/components/menu/@config/router';
import VoucherRouter from '@/components/voucher/@config/router';
import BlogRouter from '@/components/blog/@config/router';
import DealRouter from '@/components/deal/@config/router';
import PostRouter from '@/components/post/@config/router';
import AuthRouter from '@/components/auth/@config/router';
import SettingRouter from '@/components/setting/@config/router';
import BlockRouter from '@/components/block/@config/router';
import Customer from '@/components/customer/@config/router';
import SlideRouter from '@/components/slide/@config/router'
import CommunityRouter from '@/components/community/@config/router';
import PromotionRouter from '@/components/promotion/@config/router';
import BlogCollection from '@/components/blogCollection/@config/router';
import GiftRouter from '@/components/gift/@config/router';
import FilterRouter from '@/components/filters/@config/router';
import BannerRouter from '@/components/banner/@config/router';
import BodyRouter from '@/components/body/@config/router';
import FileRouter from '@/components/file/@config/router';

const routes: Array<RouteRecordRaw> = [
  AuthRouter,
  {
    path: '/',
    name: 'Trang chủ',
    beforeEnter: LayoutCheck,
    component: () => import('@/components/layout/Layout.vue'),
    children: [
      FileRouter,
      BlogRouter,
      AdminRouter,
      ProductRouter,
      MenuRouter,
      VoucherRouter,
      DealRouter,
      PostRouter,
      SettingRouter,
      BlockRouter,
      Customer,
      SlideRouter,
      CommunityRouter,
      PromotionRouter,
      BlogCollection,
      GiftRouter,
      FilterRouter,
      BannerRouter,
      BodyRouter,
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
